import {Types}        from "@Common/types";
import {formatMoney1} from "@Common/ui-components/language/format-money";

import {makeEmptyResultRows} from "./common/utils";

type ProgramResult       = Types.Apis.Payloads.Next.Reporting.TotalSpendByProgram.ProgramResult;
type ReportModuleFactory = Types.Xpresso.Account.Admin.Reporting.ActivityDashboard.ReportModuleFactory;

export const makeTotalSpendByProgramModule:ReportModuleFactory = ({apis}) => ({
    name                : "totalSpendByProgram",
    title               : "Total Spend By Program",
    supportsBranchLevel : true,
    tabs                : ["This Month", "YTD"],
    load                : async ({idBranch, idRegion}) => {
        try {
            const result = await apis.next.reporting.totalSpendByProgram({idBranch, idRegion});
            return [
                result.totalSpendByProgramMonth.length > 0
                    ? result.totalSpendByProgramMonth.map(mapResultAsTabRow)
                    : makeEmptyResultRows({titles: [""]})
                ,
                result.totalSpendByProgramYear.length > 0
                    ? result.totalSpendByProgramYear.map(mapResultAsTabRow)
                    : makeEmptyResultRows({titles: [""]})
                ,
            ];
        } catch (error) {
            console.error(error);

            const emptyResultTab = makeEmptyResultRows({titles: [""]});
            return [emptyResultTab, emptyResultTab];
        }
    },
});

const mapResultAsTabRow = (result:ProgramResult) => ({
    content : formatMoney1(result.sum_total),
    title   : result.name,
});

